import dynamic from 'next/dynamic';

import type { LoaderProps } from 'components/Loader/types';

const LoaderIcon = dynamic(
  () => import('@picsart/design-system/components/Loader').then(mod => mod.Loader),
  {
    ssr: false,
  },
);
const Loader = function ({ mode, isLoading }: LoaderProps) {
  if (isLoading) {
    return <LoaderIcon dataTestId={'loader'} variant={mode} isWithoutBackground />;
  }

  return null;
};

export default Loader;
